const months = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export default function monthName(monthIndex: number): string {
  return months[monthIndex] || '';
}